import * as type from "../types";
import moment from "moment-timezone";
import { get } from '../../config/Requests';
import { apiCarBrandId, apiCarFuelTypeId, apiCarGroupId } from '../../utils/staticData';
import { commonFiltersRoute } from '../../config/routes';

export const setSearchField = value => {
    return dispatch => {
        dispatch({
            type: type.SET_SEARCH_FIELD,
            value: value
        });
    };
};

export const changeStartDate = (date) => {
    return dispatch => {
        dispatch({
            type: type.CHANGE_START_DATE,
            value: moment(date).unix()
        });
    };
};

export const changeEndDate = (date) => {
    return (dispatch) => {
        dispatch({
            type: type.CHANGE_END_DATE,
            value: moment(date).unix()
        });
    };
};

export const changeGroupFilter = (value) => {
    return (dispatch) => {
        dispatch({
            type: type.CHANGE_GROUP_FILTER,
            value: value
        });
    };
};

export const changeBrandFilter = (value) => {
    return (dispatch, getState) => {
        let allModels = getState().filterReducer.allModelOptions;
        if (value) {
            let models = allModels.filter(model => model.marka_id === value.id);
            dispatch({
                type: type.SET_MODELS_FILTER,
                value: mapFilterData(models, "model_id", "model")
            });
        }
        else {
            dispatch({
                type: type.SET_MODELS_FILTER,
                value: []
            });
        }
        dispatch({
            type: type.CHANGE_BRAND_FILTER,
            value: value
        });
        dispatch({
            type: type.CHANGE_MODEL_FILTER,
            value: ""
        });
    };
};

export const changeModelFilter = (state) => {
    return dispatch => {
        dispatch({
            type: type.CHANGE_MODEL_FILTER,
            value: state
        });
    };
};

export const changeFuelType = (state) => {
    return dispatch => {
        dispatch({
            type: type.CHANGE_FUEL_TYPE_FILTER,
            value: state
        });
    };
};

export const changeGearBoxFilter = value => {
    return dispatch => {
        dispatch({
            type: type.CHANGE_GEARBOX_FILTER,
            value: value
        });
    };
};

export const changeGprsFilter = value => {
    return dispatch => {
        dispatch({
            type: type.CHANGE_GPRS_FILTER,
            value: value
        });
    };
};

export const changeShowDriveFilter = () => {
    return dispatch => {
        dispatch({
            type: type.CHANGE_DRIVE_FILTER,
        });
    };
};

export const setShowDriveFilter = newFilterState => {
    return dispatch => {
        dispatch({
            type: type.SET_DRIVE_FILTER,
            value: newFilterState
        });
    };
};

export const changeShowRefuelFilter = () => {
    return dispatch => {
        dispatch({
            type: type.CHANGE_REFUEL_FILTER,
        });
    };
};

export const changeShowOutOfRegionFilter = () => {
    return dispatch => {
        dispatch({
            type: type.CHANGE_REGION_FILTER,
        });
    };
};

export const changeShowWarningsFilter = () => {
    return dispatch => {
        dispatch({
            type: type.CHANGE_WARNINGS_FILTER,
        });
    };
};

export const changeInServiceFilter = () => {
    return dispatch => {
        dispatch({
            type: type.CHANGE_INSERVICE_FILTER
        });
    };
};

export const showInServiceFilter = () => {
    return dispatch => {
        dispatch({
            type: type.SHOW_INSERVICE_FILTER
        });
    };
}

export const changeShowArchivedFilter = () => {
    return dispatch => {
        dispatch({
            type: type.CHANGE_SHOW_ARCHIVED_FILTER
        });
    };
};

export const showArchivedFilter = () => {
    return dispatch => {
        dispatch({
            type: type.SHOW_ARCHIVED_FILTER
        });
    };
};

export const showPoiOnMapFilter = () => {
    return dispatch => {
        dispatch({
            type: type.SHOW_POI_ON_MAP_FILTER
        });
    };
};

export const changeShowNotArchivedFilter = () => {
    return dispatch => {
        dispatch({
            type: type.CHANGE_SHOW_NOT_ARCHIVED_FILTER
        });
    };
};

export const resetToDefaults = () => {
    return dispatch => {
        dispatch({
            type: type.CHANGE_FILTERS_DEFAULT
        });
    };
};

export const getFilters = () => {
    return dispatch => {
        get(
            dispatch,
            commonFiltersRoute,
            { },
            response => fetchFilters(dispatch, response.data)
        );
    };
};

const fetchFilters = (dispatch, data) => {
    dispatch({
        type: type.SET_GROUPS_FILTER,
        value: mapFilterData(data.grupy, apiCarGroupId, "grupa")
    });
    dispatch({
        type: type.SET_BRANDS_FILTER,
        value: mapFilterData(data.marki, apiCarBrandId, "marka")
    });
    dispatch({
        type: type.SET_ALL_MODELS_FILTER,
        value: data.modele
    });
    dispatch({
        type: type.SET_FUELTYPES_FILTER,
        value: mapFilterData(data.paliwa, apiCarFuelTypeId, "paliwo")
    });
    dispatch({
        type: type.SET_GEARBOXES_FILTER,
        value: mapFilterData(data.skrzynie, "skrzynia_id", "skrzynia")
    });
};

export function mapFilterData(data, idName, elementName) {
    return data.map(element => {
        return {
            id: element[idName],
            name: element[elementName]
        };
    });
}

export const setFilterAddressStreetField = value => {
    return dispatch => {
        dispatch({
            type: type.SET_ADDRESS_STREET,
            value: value
        });
    };
};

export const setFilterAddressCityField = value => {
    return dispatch => {
        dispatch({
            type: type.SET_ADDRESS_CITY,
            value: value
        });
    };
};


export const setFilterAddressPostalCodeField = value => {
    return dispatch => {
        dispatch({
            type: type.SET_ADDRESS_POSTAL_CODE,
            value: value
        });
    };
};


export const setFilterAddressRadiusField = value => {
    return dispatch => {
        dispatch({
            type: type.SET_ADDRESS_RADIUS,
            value: value
        });
    };
};